// extracted by mini-css-extract-plugin
module.exports = {"layoutContentDiv":"Layout_layoutContentDiv__TsbZF","pageWrapper":"Layout_pageWrapper__SFNIw"};